// extracted by mini-css-extract-plugin
export default {"linkLotsUnknownError":"linkLotsUnknownError-snY6l"};